{
  "login": "登录",
  "logout": "退出登录",
  "signOut": "退出登录",
  "username": "用户名",
  "password": "密码",
  "forgotPassword": "忘记密码？",
  "rememberMe": "记住我",
  "loginButton": "登录",
  "loginError": "用户名或密码错误",
  "sessionExpired": "您的会话已过期，请重新登录。",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "正在登录...",
  "loginSuccess": "登录成功",
  "showPassword": "显示密码",
  "hidePassword": "隐藏密码",
  "onboardingPrompt": "为您的医院或诊所?",
  "onboardingCta": "申请开通",
  "loginFailed": "登录失败",
  "seatCapReached": "已达到此许可证的用户上限。请联系管理员。",
  "mfaCodeLabel": "验证码",
  "mfaCodePrompt": "请输入身份验证器应用中的6位验证码以完成登录。",
  "mfaSetupRequired": "您的机构要求启用多重身份验证。请设置您的身份验证器应用后继续。",
  "mfaCodePlaceholder": "6位验证码",
  "mfaInvalidCode": "验证码无效",
  "pages": {
    "userProfile": {
      "title": "我的账户",
      "loading": "正在加载账户信息...",
      "sections": {
        "profilePicture": "头像",
        "personalInformation": "个人信息",
        "changePassword": "修改密码",
        "multiFactorAuth": "多因素认证"
      },
      "fields": {
        "fullName": "姓名",
        "email": "邮箱",
        "phone": "电话",
        "currentPassword": "当前密码",
        "newPassword": "新密码",
        "confirmPassword": "确认新密码",
        "required": "*"
      },
      "actions": {
        "saveChanges": "保存更改",
        "changePassword": "修改密码",
        "setUpMfa": "设置多因素认证",
        "uploadAvatar": "上传",
        "changeAvatar": "更换",
        "removeAvatar": "移除",
        "verify": "验证"
      },
      "avatar": {
        "alt": "头像",
        "helperText": "支持 PNG、JPEG 或 WebP 格式，最大 4 MB。上传前将调整为 {{size}}×{{size}}。"
      },
      "mfa": {
        "enabledMessage": "您的账户已启用多因素认证。",
        "intro": "启用多因素认证，为您的账户增加一层安全保护。",
        "scanInstruction": "使用您的身份验证器应用扫描此 URI，或手动复制：",
        "copyUri": "复制 URI",
        "verificationCode": "验证码",
        "codePlaceholder": "请输入 6 位验证码"
      },
      "validation": {
        "fullNameRequired": "请输入姓名",
        "emailRequired": "请输入有效的邮箱地址",
        "currentPasswordRequired": "请输入当前密码",
        "newPasswordTooShort": "密码至少需要 8 个字符",
        "confirmPasswordRequired": "请确认密码",
        "passwordsMismatch": "两次输入的密码不一致"
      },
      "toasts": {
        "profileUpdated": "账户信息已更新",
        "profileUpdateFailed": "账户信息更新失败",
        "passwordChanged": "密码已成功修改",
        "passwordChangeFailed": "修改密码失败，请检查当前密码是否正确。",
        "mfaSetupFailed": "无法启动多因素认证设置",
        "mfaEnabled": "多因素认证已启用",
        "mfaInvalidCode": "验证码无效",
        "avatarUpdated": "头像已更新",
        "avatarUpdateFailed": "头像更新失败",
        "avatarRemoved": "头像已移除",
        "avatarRemoveFailed": "头像移除失败",
        "imageTooLarge": "图片大小不能超过 4 MB",
        "imageTooLargeServer": "图片过大，请选择较小的文件",
        "copiedToClipboard": "已复制到剪贴板"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "您的会话将在 1 分钟内过期，请立即保存您的工作。",
      "expiringSoon_one": "您的会话将在 {{count}} 分钟后过期。",
      "expiringSoon_other": "您的会话将在 {{count}} 分钟后过期。",
      "extendButton": "延长会话"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "初始设置",
    "subtitle": "为此安装创建第一个管理员帐户。",
    "username": "用户名",
    "password": "密码",
    "confirmPassword": "确认密码",
    "fullName": "全名（可选）",
    "fullNamePlaceholder": "例如：陈伟明",
    "email": "电子邮箱（可选）",
    "submit": "创建管理员帐户",
    "submitting": "正在创建帐户…",
    "usernameHint": "3–64 个字符：小写字母、数字、点、下划线和连字符。",
    "passwordHint": "至少 12 个字符，包含大写字母、小写字母、数字和特殊字符。",
    "errUsername": "请使用 3–64 个字符：a–z、0–9、点、下划线或连字符。",
    "errPasswordLength": "密码长度至少为 12 个字符。",
    "errPasswordUpper": "密码必须包含大写字母。",
    "errPasswordLower": "密码必须包含小写字母。",
    "errPasswordDigit": "密码必须包含数字。",
    "errPasswordSpecial": "密码必须包含特殊字符。",
    "errConfirmRequired": "请确认密码。",
    "errConfirmMismatch": "两次输入的密码不一致。",
    "errFullName": "全名不得超过 100 个字符。",
    "errEmail": "请输入有效的电子邮箱地址。",
    "successTitle": "管理员帐户已创建",
    "successBody": "帐户“{{username}}”已就绪。请登录以继续。",
    "goToLogin": "前往登录",
    "claimedTitle": "设置已完成",
    "claimedBody": "该系统已有管理员。请使用您的帐户登录。",
    "networkError": "无法连接到服务器。请检查网络连接后重试。",
    "retry": "重试",
    "rateLimited": "尝试次数过多。请稍候一分钟再试。",
    "usernameTaken": "该用户名已被使用。",
    "submitFailed": "无法创建帐户。请重试。"
  }
}
